import React from 'react';
import { Link} from "react-router-dom";
import { config } from '../Configurator';
import './../components/CssCustomizer';
import CssCustomizer from './../components/CssCustomizer';
import LetteredAvatar from 'react-lettered-avatar';

const Navbar = () => {

    return(
        <nav className={ 'navbar navbar-expand-lg ' + (config().navbarClass==='white' ? 'navbar-light bg-white' : 'navbar-dark bg-dark') }>
                    <CssCustomizer></CssCustomizer>

        <div className="container">
            <Link to="/dash" className="navbar-brand">
                <img src={ config().logo } height="26" alt="Logo" />
            </Link>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
            </button>
        
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mr-auto">

                {/* Master Nav */}
                {/* <li className="nav-item mx-1"><Link className="nav-link" to="/dash"><img src={'/images/' + config().navIconClass + '/home-black-18dp.svg'} height="26" alt="Home" /></Link></li>
                <li className="nav-item mx-1"><Link className="nav-link" to="/prospects"><img src={'/images/' + config().navIconClass + '/person_add-24px.svg'} height="26" alt="Prospects / Customers" /></Link></li>
                <li className="nav-item mx-1"><Link className="nav-link" to="/customers"><img src={'/images/' + config().navIconClass + '/person-24px.svg'} height="26" alt="Prospects / Customers" /></Link></li>
                <li className="nav-item mx-1"><Link className="nav-link" to="/cases"><img src={'/images/' + config().navIconClass + '/work-24px.svg'} height="26" alt="Cases" /></Link></li> */}



                {/* Reward nav */}
                <li className="nav-item mx-1"><Link className="nav-link" to="/dash"><img src={'/images/' + config().navIconClass + '/home-black-18dp.svg'} height="22" alt="Home" />  Home</Link></li>
                <li className="nav-item mx-1"><Link className="nav-link" to="/prospects"><img src={'/images/' + config().navIconClass + '/lead.svg'} height="22" alt="Lead" />  Leads</Link></li>
                <li className="nav-item mx-1"><Link className="nav-link" to="/casesprospect"><img src={'/images/' + config().navIconClass + '/person_add-24px.svg'} height="22" alt="Prospects" />   Prospects</Link></li>
                <li className="nav-item mx-1"><Link className="nav-link" to="/cases"><img src={'/images/' + config().navIconClass + '/work-24px.svg'} height="22" alt="Cases" />   Cases</Link></li>
                <li className="nav-item mx-1"><Link className="nav-link" to="/sources"><img src={'/images/' + config().navIconClass + '/source.svg'} height="22" alt="Sources" />  Introducers</Link></li>

                {/* Dropdown example 
                <li class="nav-item mx-1 dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Dropdown
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <a class="dropdown-item" href="#">Action</a>
                    <a class="dropdown-item" href="#">Another action</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="#">Something else here</a>
                    </div>
                </li>
                */}


            </ul>
            <ul className="navbar-nav float-right">
                <li className="nav-item dropdown float-right">

                <span className='float-left mr-3'>
                <LetteredAvatar name={ config().personName } size={42} />
                </span>

                    <a className="nav-link dropdown-toggle dropdown-toggle-area"  id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {/* <img src={ config().personProfileImage } className="float-left img-round mr-2" height="41" /> */}
                        { config().personName }<br />
                        <small>{ config().personFunction }</small>
                    </a>
                    <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                        {/* <Link className="dropdown-item" to="/proposal">Proposal Form</Link> */}
                        {/* <Link className="dropdown-item" to="/dynamicprop">Proposal Form (API)</Link> */}
                        {/* <Link className="dropdown-item" to="/form/3">Proposal Form (API) with steps</Link> */}
                        {/* <Link className="dropdown-item" to="/articles/index">Articles</Link> */}
                        {/* <div className="dropdown-divider"></div> */}

                        {config().nav_links.map((value, index) => {
                            return <Link key={index} className="dropdown-item" to={value[0]}>{value[1]}</Link>
                        })}

                        <div className="dropdown-divider"></div>
                        <Link className="dropdown-item" to="/logout">Logout</Link>
                    </div> 
                </li>
            </ul>
            </div>
        </div>
      </nav>
        );

}

export default Navbar;